








import { Component } from 'vue-property-decorator'

import Field from './Field.vue'
import TrueFalse from '@/components/common/TrueFalse.vue'

@Component({
  components: { TrueFalse }
})
export default class FieldBoolean extends Field {

  get currentValue() {
    return this.field.value
  }

  beforeUpdateField(field, value) {
    this.updateField(field, value.toString())
  }
}
